(function() {
    'use strict';

    angular
        .module('atheer.sdk', [

        ]);
})();
